import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { CountryService } from "../country/service/country.service";
import { StateService } from "../state/service/state.service";
import { CityService } from "../city/service/city.service";
import { CategoryService } from "src/app/services/category.service";
import { AcademyService } from "../academies/service/academies.service";
import { ReportService } from "src/app/services/report.service";
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Table } from "primeng/table";

@Component({
  selector: 'app-academy-affiliation-revenue',
  templateUrl: './academy-affiliation-revenue.component.html',
  styleUrls: ['./academy-affiliation-revenue.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})

export class AcademyAffiliationRevenueComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = "";
  searchBy: any[];
  totalRecords: 0;
  academyAffiliationRevenueData: any;
  loading: boolean;
  paginationOption;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  @ViewChild("dt", { static: false }) public dt: Table;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  searchby;
  public hide: boolean = true;
  sportList: any;
  countrylist: any[];
  stateList: any[];
  cityList: any[];
  countryCode: string;
  academiesList: any;
  country: any;
  state: any;
  cityName: any;
  sportName: any;
  academyId: any;
  downloadAcademyAffiliationRevenueDataList: any;
  couponFilterOptions: any[];

  constructor(
    private countryService: CountryService,
    private stateService: StateService,
    private cityService: CityService,
    private categoryService: CategoryService,
    private academyService: AcademyService,
    private reportService: ReportService
  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" }
    ];
    this.searchby = this.searchBy[0];
    this.couponFilterOptions = [
      { label: 'Yes', value: true },
      { label: 'No', value: false },
    ];
    this.downloadFlg = false;
    this.getCountries();
    this.getSportList();
    this.getAcademies();
  }

  getAcademies() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.academyService.getAcademyList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.academiesList = data.data.items;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getSportList() {
    const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sport`;
    this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.sportList = data?.data?.items;
    }, err => {
      this.errorMessage = err.error.message;
    })
  }

  getCountries() {
    this.countrylist = [];
    this.stateList = [];
    this.cityList = [];
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getStates(event) {
    this.stateList = [];
    this.cityList = [];
    this.state = null;
    this.cityName = null;
    if (event.value !== null) {
      let countryCode = event.value.iso2;
      let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + countryCode;
      this.stateService.getstateList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
  
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let stateObj = {
              name: element.name,
              id: element.id,
            }
            this.stateList.push(stateObj);
          });
        }
      })
    }
    this.loadAcademyAffiliationRevenue(this.lastTableLazyLoadEvent);
  }

  async getCities(event) {
    this.cityList = [];
    this.cityName = null;
    if (event.value !== null) {
      const stateCode = event.value.id;
      let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateCode;
      this.cityService.getcityList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let cityObj = {
              name: element.name,
              code: element.name,
            }
            this.cityList.push(cityObj);
          });
        }
      })
    }
    this.loadAcademyAffiliationRevenue(this.lastTableLazyLoadEvent);
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = this.searchBy[0];
    this.stateList = [];
    this.cityList = [];
    this.country = null;
    this.state = null;
    this.cityName = null;
    this.sportName = null;
    this.academyId = null;
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0, filters: {} });
    if (this.dt) {
      this.dt.filters = {};
      this.dt.first = 0;
    }
    this.loadAcademyAffiliationRevenue(resetEvent);
  }

  loadAcademyAffiliationRevenue(event: LazyLoadEvent) {
    event = event || {} as LazyLoadEvent;
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.searchby != undefined && (this.startDate != undefined || this.endDate != undefined)) {
      params += "&filterByDate=" + this.searchby.value;
      if (this.startDate != undefined) {
        params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      }
      if (this.endDate != undefined) {
        params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
      }
    }

    if (this.country) {
      params += "&filterByCountries=" + this.country.name;
    }

    if (this.state) {
      params += "&filterByState=" + this.state.name;
    }

    if (this.cityName) {
      params += "&filterByCity=" + this.cityName;
    }

    if (this.sportName) {
      params += "&filterBySportwise=" + this.sportName;
    }

    if (this.academyId) {
      params += "&filterByAcademy=" + this.academyId;
    }

    const getFilterValue = (field) => {
      if (event.filters != undefined && event.filters[field] != undefined && event.filters[field].value !== undefined && event.filters[field].value !== null && event.filters[field].value !== "") {
        return event.filters[field].value;
      }
      return null;
    };
    const columnFilters = [
      { field: "mobileNumber", parameter: "filterByAffiliationMobileNumber" },
      { field: "academyName", parameter: "filterByAffiliationAcademyName" },
      { field: "affiliationId", parameter: "filterByAffiliationId" },
      { field: "affiliationLevel", parameter: "filterByAffiliationLevel" },
      { field: "affiliationStartDate", parameter: "filterByAffiliationStartDate" },
      { field: "affiliationEndDate", parameter: "filterByAffiliationEndDate" },
      { field: "city", parameter: "filterByAffiliationCity" },
      { field: "state", parameter: "filterByAffiliationState" },
      { field: "country", parameter: "filterByAffiliationCountry" },
      { field: "address", parameter: "filterByAffiliationAddress" },
      { field: "affiliationAmount", parameter: "filterByAffiliationAmount" },
      { field: "couponApplied", parameter: "filterByCouponApplied" },
      { field: "couponAmount", parameter: "filterByCouponAmount" },
      { field: "totalAffiliationAmount", parameter: "filterByTotalAffiliationAmount" },
      { field: "gstAmount", parameter: "filterByGstAmount" },
    ];

    columnFilters.forEach(columnFilter => {
      const value = getFilterValue(columnFilter.field);
      if (value !== null) {
        params += "&" + columnFilter.parameter + "=" + encodeURIComponent(String(value));
      }
    });

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "ASC";
      } else {
        orderBy = "DESC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.reportService.getAcademyAffiliationRevenue(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        if (this.downloadFlg === false) {
          this.loading = false;
          this.academyAffiliationRevenueData = data;
          this.totalRecords = data.totalCount;
        } else {
          this.exportAcademyAffiliationRevenueReportListData(data);
          this.downloadFlg = false;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadAcademyAffiliationRevenue(this.lastTableLazyLoadEvent);
  }

  async exportAcademyAffiliationRevenueReportListData(userReportList) {
    this.downloadAcademyAffiliationRevenueDataList = JSON.parse(JSON.stringify(userReportList));
    var propertiesRemove = ['message', 'pageNumber', 'pageSize', 'status', 'totalCount', 'totalPages'];
    propertiesRemove.forEach((prop) => {
      delete this.downloadAcademyAffiliationRevenueDataList[prop];
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([]);

    // Set column widths
    const colWidths = [
      { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 20 }, { wch: 25 },
      { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 15 }, { wch: 15 }, { wch: 35 }
    ];
    worksheet['!cols'] = colWidths;

    // Add parent section with visual separation
    const parentSection = [
      [],
      ["Total Number of Academies", "Total Platinum Affiliations", "Revenue - Platinum Affiliations", "Total Gold Affiliations", "Revenue - Gold Affiliations", "Total Silver Affiliations", "Revenue - Silver Affiliations", "Coupon Amount", "Total Revenue"],
      [this.downloadAcademyAffiliationRevenueDataList.summary.totalNumberOfAcademies, this.downloadAcademyAffiliationRevenueDataList.summary.totalPlatinumAffiliations, this.downloadAcademyAffiliationRevenueDataList.summary.revenuePlatinumAffiliations, this.downloadAcademyAffiliationRevenueDataList.summary.totalGoldAffiliations, this.downloadAcademyAffiliationRevenueDataList.summary.revenueGoldAffiliations, this.downloadAcademyAffiliationRevenueDataList.summary.totalSilverAffiliations, this.downloadAcademyAffiliationRevenueDataList.summary.revenueSilverAffiliations, this.downloadAcademyAffiliationRevenueDataList.summary.couponAmount, this.downloadAcademyAffiliationRevenueDataList.summary.totalRevenue],
      [],
      ['Mobile Number', 'Academy Name', 'Affiliation ID', 'Affiliation Level', 'Affiliation Start Date', 'Affiliation End Date', 'City', 'State', 'Country', 'Address', 'Affiliation amount', 'Coupon Applied', 'Coupon Amount', 'Total Affiliation Amount', 'GST Amount']
    ];

    XLSX.utils.sheet_add_aoa(worksheet, parentSection, { origin: -1 });

    this.downloadAcademyAffiliationRevenueDataList['data'].forEach((parent: any) => {
      if (parent.affiliationStartDate) {
        parent.affiliationStartDate = moment(parent.affiliationStartDate).format("DD-MM-YYYY");
      }
      if (parent.affiliationEndDate) {
        parent.affiliationEndDate = moment(parent.affiliationEndDate).format("DD-MM-YYYY");
      }
      XLSX.utils.sheet_add_aoa(worksheet, [
        [
          parent.mobileNumber,
          parent.academyName,
          parent.affiliationId,
          parent.affiliationLevel,
          parent.affiliationStartDate,
          parent.affiliationEndDate,
          parent.city,
          parent.state,
          parent.country,
          parent.address,
          parent.affiliationAmount,
          parent.couponApplied,
          parent.couponAmount,
          parent.totalAffiliationAmount,
          parent.gstAmount
        ],
      ], { origin: -1 });
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, "Academy_Affiliation_Revenue");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([excelBuffer]), "Academy_Affiliation_Revenue.xlsx");

    this.downloadFlg = false;
  }

  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }

  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
